module.exports = __webpack_public_path__ + "static/media/choose-type-modal1.220d4314.svg";